// Device detection helper
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for mobile devices
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  // Check for tablet devices
  const tabletRegex = /iPad|Android(?!.*Mobile)/i;

  // Check if it's a mobile or tablet
  const isMobile = mobileRegex.test(userAgent);
  const isTablet = tabletRegex.test(userAgent);

  // Also check screen size as a fallback
  const hasSmallScreen = window.innerWidth <= 768;

  return isMobile || isTablet || hasSmallScreen;
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|Android(?!.*Mobile)/i.test(userAgent)) {
    return "tablet";
  }

  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return "mobile";
  }

  return "desktop";
};
